"use client";
import * as t from "react";
import { u as J } from "./useEventCallback-CjuAhyNz.mjs";
import { D as K, F as Q, f as x, u as M } from "./FieldRootContext-Cj7-dNhd.mjs";
import { u as W } from "./FieldsetRootContext-DS-ONKHT.mjs";
import { u as L } from "./FormContext-CYX6HnEQ.mjs";
import { u as g } from "./useRenderElement-B8V3_e8R.mjs";
import { j as X } from "./jsx-runtime-CJ-St4mQ.mjs";
import { u as O } from "./useIsoLayoutEffect-DpJo20by.mjs";
import { u as j } from "./useBaseUiId-a-UPSsPQ.mjs";
const Z = /* @__PURE__ */ t.forwardRef(function(r, c) {
  const {
    render: h,
    className: f,
    validate: I,
    validationDebounceTime: a = 0,
    validationMode: d = "onBlur",
    name: e,
    disabled: s = !1,
    invalid: m,
    ...n
  } = r, {
    disabled: l
  } = W(), {
    errors: p
  } = L(), u = J(I || (() => null)), o = l || s, [v, i] = t.useState(void 0), [F, A] = t.useState(void 0), [k, H] = t.useState([]), [E, U] = t.useState(!1), [y, Y] = t.useState(!1), [D, C] = t.useState(!1), [R, P] = t.useState(!1), T = t.useRef(!1), w = t.useCallback((B) => {
    B && (T.current = !0), Y(B);
  }, []), N = !!(m || e && {}.hasOwnProperty.call(p, e) && p[e] !== void 0), [S, q] = t.useState({
    state: K,
    error: "",
    errors: [],
    value: null,
    initialValue: null
  }), _ = !N && S.state.valid, b = t.useMemo(() => ({
    disabled: o,
    touched: E,
    dirty: y,
    valid: _,
    filled: D,
    focused: R
  }), [o, E, y, _, D, R]), z = t.useMemo(() => ({
    invalid: N,
    controlId: v,
    setControlId: i,
    labelId: F,
    setLabelId: A,
    messageIds: k,
    setMessageIds: H,
    name: e,
    validityData: S,
    setValidityData: q,
    disabled: o,
    touched: E,
    setTouched: U,
    dirty: y,
    setDirty: w,
    filled: D,
    setFilled: C,
    focused: R,
    setFocused: P,
    validate: u,
    validationMode: d,
    validationDebounceTime: a,
    state: b,
    markedDirtyRef: T
  }), [N, v, F, k, e, S, o, E, y, w, D, C, R, P, u, d, a, b]), G = g("div", r, {
    ref: c,
    state: b,
    props: n,
    customStyleHookMapping: x
  });
  return /* @__PURE__ */ X.jsx(Q.Provider, {
    value: z,
    children: G
  });
});
process.env.NODE_ENV !== "production" && (Z.displayName = "FieldRoot");
const $ = /* @__PURE__ */ t.forwardRef(function(r, c) {
  const {
    render: h,
    id: f,
    className: I,
    match: a,
    ...d
  } = r, e = j(f), {
    validityData: s,
    state: m,
    name: n,
    setMessageIds: l
  } = M(!1), {
    errors: p
  } = L(), u = n ? p[n] : null;
  let o = !1;
  u || a === !0 ? o = !0 : a ? o = !!s.state[a] : o = s.state.valid === !1, O(() => {
    if (!(!o || !e))
      return l((i) => i.concat(e)), () => {
        l((i) => i.filter((F) => F !== e));
      };
  }, [o, e, l]);
  const v = g("div", r, {
    ref: c,
    state: m,
    props: [{
      id: e,
      children: u || (s.errors.length > 1 ? /* @__PURE__ */ t.createElement("ul", {}, s.errors.map((i) => /* @__PURE__ */ t.createElement("li", {
        key: i
      }, i))) : s.error)
    }, d],
    customStyleHookMapping: x
  });
  return o ? v : null;
});
process.env.NODE_ENV !== "production" && ($.displayName = "FieldError");
const ee = /* @__PURE__ */ t.forwardRef(function(r, c) {
  const {
    render: h,
    id: f,
    className: I,
    ...a
  } = r, {
    state: d
  } = M(!1), e = j(f), {
    setMessageIds: s
  } = M();
  return O(() => {
    if (e)
      return s((n) => n.concat(e)), () => {
        s((n) => n.filter((l) => l !== e));
      };
  }, [e, s]), g("p", r, {
    ref: c,
    state: d,
    props: [{
      id: e
    }, a],
    customStyleHookMapping: x
  });
});
process.env.NODE_ENV !== "production" && (ee.displayName = "FieldDescription");
export {
  Z as F,
  $ as a,
  ee as b
};
